import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. Acceptance of Terms',
    body: `By creating an account, downloading, or playing HiveFall ("the Game"), you agree to these Terms & Conditions. If you do not agree, please do not use the Game or this website.`,
  },
  {
    title: '2. Accounts',
    body: `You may need an account to save progress, sync across devices, or access online features. You're responsible for keeping your login credentials secure and for all activity under your account. You must provide accurate information when registering.`,
  },
  {
    title: '3. Acceptable Use',
    body: `You agree not to: cheat, exploit bugs, or use unauthorized third-party software to gain an unfair advantage; harass or abuse other players; attempt to reverse engineer, decompile, or disrupt the Game's servers or infrastructure; or use the Game for any unlawful purpose.`,
  },
  {
    title: '4. Intellectual Property',
    body: `HiveFall, including its name, logo, characters, art, story, and code, is owned by its developers and protected by copyright and trademark law. You may not copy, redistribute, or create derivative works without written permission.`,
  },
  {
    title: '5. In-Game Content & Progress',
    body: `Save data, progress, and in-game items are provided for your personal, non-commercial use. We do not guarantee that progress will be preserved indefinitely, and we may reset, wipe, or modify game data during updates, especially in early access or beta periods.`,
  },
  {
    title: '6. Availability & Changes',
    body: `HiveFall is under active development. Features, balance, biomes, and systems described on this site may change before or after release. We may suspend, modify, or discontinue any part of the Game or this website at any time.`,
  },
  {
    title: '7. Termination',
    body: `We may suspend or terminate accounts that violate these terms, including cheating, abusive behavior, or attempts to compromise the Game's security. You may stop using the Game and request account deletion at any time.`,
  },
  {
    title: '8. Disclaimer & Limitation of Liability',
    body: `The Game and website are provided "as is" without warranties of any kind. To the fullest extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the Game or website.`,
  },
  {
    title: '9. Changes to These Terms',
    body: `We may update these Terms from time to time. Continued use of the Game or website after changes are posted means you accept the updated Terms.`,
  },
  {
    title: '10. Contact',
    body: `Questions about these Terms? Reach us via the Support page or email support@playhivefall.com.`,
  },
];

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Legal</span>
        <h1 className="page-title section-gap">Terms &amp; Conditions</h1>
        <p className="page-subtitle">
          Last updated August 8, 2026. These terms govern your use of HiveFall and this website.
        </p>

        <div className="mt-8 space-y-6">
          {sections.map((s) => (
            <div key={s.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
              <h2 className="text-base font-black text-slate-900">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </div>
          ))}
        </div>

        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
